import Popper from 'popper.js';
// @ts-ignore
export const createPopper = (ref, popperRef, options) => {
  return new Popper(ref, popperRef, options);
};
